<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12 transparent-bg login-form">
              <b-card-body id="login-form">
                <b-form>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_login.email_placeholder')"
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"
                                  @keyup.enter="submit"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">{{$t('enduser_login.invalidEmailFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_login.password_placeholder')"
                                  v-model.lazy.trim="$v.password.$model"
                                  :state="chkState('password')"
                                  aria-describedby="invalidPasswordFeedback"
                                  @keyup.enter="submit"/>
                    <b-form-invalid-feedback id="invalidPasswordFeedback">{{$t('enduser_login.invalidPasswordFeedback', { min: $v.password.$params.minLength.min})}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" class="w-100 px-4" @click="submit()">{{$t('enduser_login.submit')}}</b-button>
                    </b-col>
                    <br/>
                    <b-col cols="12" v-show="show_dir_btn">
                      <b-button variant="success" class="w-100 px-4 mt-3" @click="gotoDirCharging()">{{$t('enduser_login.gotoDirCharging')}}</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:1.2rem;">
                      <h5 class="d-inline pointer w-50" @click="gotoRegister()" :class="show_register_btn?'':'hidden'"><i class="fa fa-user-plus"></i> {{$t('enduser_login.gotoRegister')}} &nbsp;&nbsp;</h5>
                      <h5 class="d-inline pointer w-50" @click="gotoResetPassword()"><i class="fa fa-key"></i> {{$t('enduser_login.gotoResetPassword')}} </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:2rem;">
                      <h5 class="d-inline pointer w-50"><i class="fa fa-globe"></i>&nbsp;&nbsp;</h5>
                      <span @click="switchChange" class="clickable-text">{{$i18n.locale == 'zh_TW' ? 'English' : '中文(繁體)'}}</span>
                      <!--<select v-model="selectlanguage" class="d-inline pointer w-20" @change="handleChange">
                        <option v-for="option in language_options" :value="option.value" :key="option.value">
                          {{ option.label }}
                        </option>
                      </select>-->
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-3 ml-auto text-white pri-info-declaration text-center">
                        <a href="https://lin.ee/1XYXjce" target="_blank">創玖科技官方LINE群</a>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-1 ml-auto text-white pri-info-declaration text-center">
                        <span v-html="PrivacyPolicy"></span> 
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="ml-auto text-white pri-info-declaration text-center">
                        {{$t('innoknight') + '©' + thisyear}}
                      </div>
                    </b-col>
                  </b-row>

                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const mail_or_phone = (value) => {
  const phoneRegex = /^09\d{8}$/;
  //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return (phoneRegex.test(value || '') || emailRegex.test(value || ''));
};

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

const get_access_token = function (username, secret, google_captcha) {
  let auth_token = generateRandomToken();
  let action = `${api_root}/get_end_user_token`;
  let params = {
    keyset: 'mqtt',
    access: encodeURIComponent(encrypt(JSON.stringify({username, secret, google_captcha}))),
    bring_navs: true,
  };

  if(config.page_configs && config.page_configs.login_model){
    params['login_model'] = config.page_configs.login_model;
  }

  return fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + auth_token
    },
    body: JSON.stringify(params)
  });
};//eo get_access_token

export default {
  name: 'Login',
  notifications,
  components: {
    vSelect
  },

  beforeMount() {
    let pre_error = this.$state.$get('error');
    let device_id = this.$state.$get('device_id');

    let preemail = this.$state.$get('email');
    let prepass = this.$state.$get('ipsd');
    this.$state.$del('password');
    let preusername = this.$state.$get('username');

    if (preusername) {
      this.username = preusername;
    }

    if (preemail) {
      this.username = preemail;
    }

    if (prepass) {
      this.password = decrypt(prepass, config.ffkey, config.ffiv);
    }

    // console.info('device_id: ', device_id);

    if(pre_error === config.error.INVALID_USER){
      // this.showError({message:'請先登入', title:'使用者尚未通過驗證'});
      this.$state.$del('error');
      return false;
    }

    // if login 
    const login = this.$state.$get('user');
    //console.info('login: ', login);

    let keyword = this.$state.$get('keyword');
    if(login && keyword) {
      //console.info('beforeMount EndUserLogin keyword:', keyword);
      this.$router.push('/search/devices');
    } else if(login && login.after_login_page){
      this.$router.push(login.after_login_page);
    } else if (login && login.uuid) {
      this.$router.push('/dashboard/showdevice');
    } else if (!login) {
      this.show_dir_btn = true;
    }
  },//eo beforeMount

  mounted(){
    // console.info('okay: ', this.$state.$get('user'));
    if(config.styles && config.styles){
      // console.info('config.styles:', config.styles);
      jQuery('.app').css(config.styles);
    }

    if(config.overwritetitle){
      // console.info('config.overwritetitle:', config.overwritetitle);
      document.title = config.overwritetitle;
    }

    this.generateLanguage();
  },//eo mounted

  data() {

    // console.info('config.page_configs.show_register_btn:', config.page_configs.show_register_btn);

    let show_register_btn = true;

    if(config.page_configs && config.page_configs.show_register_btn !== undefined){
      show_register_btn = config.page_configs.show_register_btn;
    }

    const this_year = new Date();

    return {
      username:       '',
      password:       '',
      captcha_action: '',
      language_options: [],
      selectlanguage: '',
      show_dir_btn:   false,
      show_capthca:   config.show_capthca,
      captcha_action: config.captcha_action,
      show_register_btn,
      thisyear: this_year.getFullYear(),
      footer: config.footer,
    };
  },//eo data

  computed: {
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  methods: {
    gotoDirCharging() {
      this.$router.push('/dircharging');
    },
    submit(){
      // console.info('submit');
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message: this.$t('enduser_login.error.invalid_input_message'), title: this.$t('enduser_login.error.invalid_input_title')});
        return false;
      }

      this.$state.$set('email', this.username);
      this.$state.$set('ipsd', encrypt(this.password, config.ffkey, config.ffiv));

      let after = (google_captcha) => {
        google_captcha = google_captcha || null;

        let get_token = get_access_token.apply(this, [this.username, this.password, google_captcha]);
        get_token.then(res => res.json()).then(user_token => {
          if(user_token.gcc_rlt && user_token.gcc_rlt.score <= 0.1){
            // console.info('gcc_rlt:', user_token.gcc_rlt.score);
            app.showWarn({
              message: this.$t('enduser_login.warning.gcc_fail_message')
            });
            return false; 
          }
          
          if(!user_token.success){
            app.showWarn({
              message:user_token.message,  //TODO: i18n
              title: this.$t('enduser_login.warning.server_side_error')
            });
            return false;
          } else {
            app.showSuccess({
              message: this.$t('enduser_login.message.login_success_message'),
              title: this.$t('enduser_login.message.login_success_title')
            });

            this.$state.$set('user', user_token);

            // console.info('user_token:', user_token);
            let keyword = this.$state.$get('keyword');
            if(keyword) {
              //console.info('EndUserLogin keyword:', keyword);
              this.$router.push('/search/devices');
            }else if(user_token.after_login_page){
              // console.info('user_token.after_login_page:', user_token.after_login_page);
              this.$router.push(user_token.after_login_page);
            } else {
              this.$router.push('/dashboard/showdevice');
            }
          }
        }).catch((error) => {
          console.info('user_token error:', error);
          app.showWarn({
            message: this.$t('enduser_login.message.server_no_response'), 
            title: this.$t('enduser_login.warning.server_side_error')
          });
          return false;
        });
      }

      if(config.captcha){
        grecaptcha.execute(config.captcha_key, {action: 'login'})
        .then(function(token) {
          // console.info('grecaptcha.token:', token);
          after(token);
        });
      } else {
        after();
      }
    },
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },
    gotoRegister(){
      this.$router.push('/aregg');
    },//eo gotoRegister
    gotoResetPassword(){
      this.$router.push('/amnesia');
    },//eo gotoResetPassword
    generateLanguage() {
      let app = this;
      let needSave = false;
      
      //loading i18n
      //this.$i18n.locale = 'en';
      let language = this.$state.$get('language');
      if(!language) {
        language = 'zh_TW';
        //console.info('set default:', language);
        needSave = true;
      }
      if(language != this.$i18n.locale) {
        //console.info('[generateLanguage] set language to:', language);
        this.$i18n.locale = language;
        needSave = true;
      }
      if(needSave) {
        this.$state.$set('language', language);
      }
    },
    generateLanguageList() {
      let app = this;
      let needSave = false;
      this.language_options = [];

      if(this.$i18n && this.$i18n.messages) {
        //console.info('messages:', this.$i18n.messages);
        let messages = this.$i18n.messages;
        Object.keys(messages).forEach(function(key){
          const newlabel = messages[key].name;
          const newValue = key;
          //console.info(`label:${newlabel}, value:${newValue}`);
          app.language_options.push({label:newlabel, value:newValue});
        });
      }

      //loading i18n
      //this.$i18n.locale = 'en';
      let language = this.$state.$get('language');
      if(!language) {
        language = 'zh_TW';
        //console.info('set default:', language);
        needSave = true;
      }
      if(language != this.$i18n.locale) {
        //console.info('[generateLanguage] set language to:', language);
        this.$i18n.locale = language;
        needSave = true;
      }
      if(needSave) {
        this.$state.$set('language', language);
      }
      this.$nextTick(() => { 
        this.selectlanguage = language;
      });
    },
    switchChange(){
      //console.info('[switchChange] language:', this.$i18n.locale);
      let language = this.$i18n.locale == 'zh_TW' ? 'en' : 'zh_TW';

      if(language != this.$i18n.locale) {
        //console.info('[switchChange] set language to:', language);
        this.$i18n.locale = language;
        this.$state.$set('language', language);
      }
    },
    handleChange(){
      //console.info('selectlanguage:', this.selectlanguage);
      let language = this.selectlanguage;
      if(language != this.$i18n.locale) {
        //console.info('[handleChange] set language to:', language);
        this.$i18n.locale = language;
        this.$state.$set('language', language);
      }
    },
  },//eo methods

  validations: {
    username: {
      mail_or_phone,
      required,
      minLength: minLength(5)
    },
    password: {
      required,
      minLength: minLength(5),
    }
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
.pointer{
  cursor: pointer;
}
.app{
  background-color: black;
}
.login-form{
  margin-top: 4rem;
}
.hidden{
  display: none !important;
  width: 0px !important;
  height: 0px;
}
.clickable-text {
  cursor: pointer;
  color: #FFFFFF;
  text-decoration: none;
}
</style>
  